// @flow

import Symbol from 'core-js/es6/symbol';

import NodeEventEmitter from 'events';


const _emitter = Symbol('_emitter');

type PrivateEmitter = { [_emitter]: NodeEventEmitter };


export interface EventEmitterInterface {
	constructor(): void;
	on(event: string, handler: (...any) => void): EventEmitterInterface;
	once(event: string, handler: (...any) => void): EventEmitterInterface;
	emit(string, ...any): boolean;
}

export const EventEmitterMixin = (superclass: *) => class EventEmitter extends superclass {
	constructor (...args: *) {
		super(...args);

		(this: PrivateEmitter)[_emitter] = new NodeEventEmitter();
	}

	on (...args: *): EventEmitterInterface {
		return (this: PrivateEmitter)[_emitter].on(...args);
	}

	once (...args: *): EventEmitterInterface {
		return (this: PrivateEmitter)[_emitter].once(...args);
	}

	removeAllListeners (...args: *) {
		return (this: PrivateEmitter)[_emitter].removeAllListeners(...args);
	}

	removeListener (...args: *) {
		return (this: PrivateEmitter)[_emitter].removeListener(...args);
	}

	emit (...args: *): boolean {
		return (this: PrivateEmitter)[_emitter].emit(...args);
	}
};

export const EventEmitter: Class<EventEmitterInterface> = EventEmitterMixin(class {});
